import { env } from "@rsmus/react-env-image";

export const envProperties = {
  WebBaseUrl: env("REACT_APP_WEBBASE_URL"),
  ApiBackendUrl: env("REACT_APP_BASE_API_URL"),
  ApiBackendUpgradeSiteUrl: env("REACT_APP_UPGRADE_SITE_API_URL"),
  IsUpgradeSiteMicroserviceEnabled: env("REACT_APP_SITEUPGRADE_MICROSERVICE_ENABLED"),
  ApiBackendBulkSiteCreationUrl: env("REACT_APP_BULK_SITE_CREATION_API_URL"),
  ApiBackendRolloverUrl: env("REACT_APP_ROLLOVER_API_URL"),
  IsRolloverMicroserviceEnabled: env("REACT_APP_ROLLOVER_MICROSERVICE_ENABLED"),
  CemBaseUrl: env("REACT_APP_CEMBASE_URL"),
  reactAppHighQUrl: env("REACT_APP_HIGHQ_URL"),
  reactAppMdmClientIdURL: env("REACT_APP_MDM_CLIENT_ID_URL"),
  reactAppHighQSiteUrl: env("REACT_APP_HIGHQ_SITE_URL"),
  authentication: {
    clientId: env("REACT_APP_AUTH_CLIENTID"),
    authority: env("REACT_APP_AUTH_AUTHORITY"),
    scope: env("REACT_APP_AUTH_SCOPE"),
  },
  RolesFlag: env("RSM_APP_FEATURE_ROLE"),
  highQLoginUrl: env("REACT_APP_HIGHQ_LOGIN_URL"),
  userAssignmenetUrl: env("REACT_APP_USER_ASSIGNMENT_API_URL"),
};
